import React, { useMemo, useState } from "react";
import { Button } from "react-bootstrap";

const categories = ["books", "literature", "videos"];

const ResourceFilters = ({
  resources,
  selectedCategory,
  setSelectedCategory,
  selectedTags,
  setSelectedTags,
  resetFilters,
}) => {
  const [visibleTagCount, setVisibleTagCount] = useState(6);

  const tagList = useMemo(() => {
    const tags = new Set();
    resources.forEach((r) => r.tags?.forEach((t) => tags.add(t.tag)));
    return [...tags];
  }, [resources]);

  const toggleCategory = (cat) => {
    setSelectedCategory(selectedCategory === cat ? "" : cat);
  };

  const toggleTag = (tag) => {
    if (selectedTags.includes(tag)) {
      setSelectedTags(selectedTags.filter((t) => t !== tag));
    } else {
      setSelectedTags([...selectedTags, tag]);
    }
  };

  return (
    <>
      {/* CATEGORY */}
      <div className="filter-title">Category</div>
      <div className="mb-4">
        {categories.map((cat) => (
          <Button
            variant="secondary"
            key={cat}
            className={`filter-badge ${
              selectedCategory === cat
                ? "selected bg-primary text-secondary"
                : ""
            }`}
            onClick={() => toggleCategory(cat)}
          >
            {cat.charAt(0).toUpperCase() + cat.slice(1)}
          </Button>
        ))}
      </div>

      {/* TAGS */}
      <p className="filter-title">Tags</p>

      <div className="mb-3">
        {tagList.slice(0, visibleTagCount).map((tag) => (
          <Button
            variant="secondary"
            key={tag}
            className={`filter-badge ${
              selectedTags.includes(tag)
                ? "selected bg-primary text-secondary"
                : ""
            }`}
            onClick={() => toggleTag(tag)}
          >
            {tag}
          </Button>
        ))}
      </div>

      {visibleTagCount < tagList.length && (
        <Button
          variant="link "
          className="text-primary"
          onClick={() => setVisibleTagCount(visibleTagCount + 6)}
        >
          Show More ▼
        </Button>
      )}

      <div className="mt-4">
        <Button variant="primary" className="rounded-2"  onClick={resetFilters}>
          Reset
        </Button>
      </div>
    </>
  );
};

export default ResourceFilters;
